export default __webpack_public_path__ + "static/media/7.b00309eb.jpg";